import styled from 'styled-components';
import { Media } from 'assets/Mixins.style';

export const Item = styled.div`
  position: relative;
  display: block;
  width: 100%;
  max-width: ${props => props.theme.maxWidth || '320px'};
  margin: 20px auto;
`;

export const BackgroundImagebox = styled.div`
  display: block;
  width: 100%;
`;

export const BackgroundImage = styled.img`
  display: block;
  width: 100%;
  height: auto;
`;

export const Imagebox = styled.div`
  position: absolute;
  top: ${props => props.theme.top || '50%'};
  bottom: ${props => props.theme.bottom || 'auto'};
  left: ${props => props.theme.left || 'auto'};
  right: ${props => props.theme.right || 0};
  display: block;
  width: ${props => props.theme.width || '30%'};
  transform: ${props => props.theme.transform || 'translateY(-50%)'};
`;

export const Image = styled.img`
  display: block;
  max-width: 100%;
  height: auto;
  margin: 0 auto;
`;

export const Content = styled.div`
  position: absolute;
  top: ${props => props.theme.top || '50%'};
  left: ${props => props.theme.left || 0};
  display: grid;
  grid-template-columns: ${props => props.theme.gridColumns || '1fr 1fr'};
  align-items: center;
  justify-content: center;
  width: ${props => props.theme.width || '70%'};
  padding: ${props =>
    props.theme.padding ? props.theme.padding.default : '15px'};
  transform: ${props => props.theme.transform || 'translateY(-50%)'};

  ${Media.md`
    padding: ${props => (props.theme.padding ? props.theme.padding.md : '5px')};
  `}
`;

export const Title = styled.h6`
  display: block;
  max-width: 100%;
  width: 100%;
  transition: 0.2s all;
  margin: ${props => props.theme.margin && props.theme.margin.default};
  color: ${props => props.theme.color};
  font-family: ${props => props.theme.fontFamily};
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  line-height: ${props => props.theme.lineHeight};
  font-weight: ${props => props.theme.fontWeight};
  text-align: center;
  cursor: default;

  ${Media.lg`
    font-size: ${props => `${props.theme.fontSize.lg}rem`};
  `}

  ${Media.md`
    font-size: ${props => `${props.theme.fontSize.md}rem`};
  `}

  ${Media.sm`
    font-size: ${props => `${props.theme.fontSize.sm}rem`};
  `}
`;

export const Text = styled.span`
  display: block;
  max-width: 100%;
  width: 100%;
  transition: 0.2s all;
  color: ${props => props.theme.color};
  font-family: ${props => props.theme.fontFamily};
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  line-height: ${props => props.theme.lineHeight};
  font-weight: ${props => props.theme.fontWeight};
  font-style: ${props => props.theme.fontStyle};
  text-align: center;
  cursor: default;

  ${Media.lg`
    font-size: ${props => `${props.theme.fontSize.lg}rem`};
  `}

  ${Media.md`
    font-size: ${props => `${props.theme.fontSize.md}rem`};
  `}

  ${Media.sm`
    font-size: ${props => `${props.theme.fontSize.sm}rem`};
  `}
`;
